export default __webpack_public_path__ + "pgnv-assets/b65b126b59221bc8f93324c43f430aa3.png";